module.exports = __webpack_public_path__ + "img/partner_01.db91244b.png";